import { uaLimitedReleasesListConstants } from "../_redux-constants";

export function uaLimitedReleasesListReducer(
  state = {
    uaLimitedReleasesListLoading: false,
    uaLimitedReleasesListData: null,
    uaLimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        uaLimitedReleasesListLoading: true,
        uaLimitedReleasesListData: null,
        uaLimitedReleasesListError: null,
      });
    case uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        uaLimitedReleasesListLoading: false,
        uaLimitedReleasesListData: action.data,
      });
    case uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        uaLimitedReleasesListLoading: false,
        uaLimitedReleasesListData: null,
        uaLimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
